import { render, staticRenderFns } from "./UpdateMailCharge.vue?vue&type=template&id=baf8e4d0&scoped=true"
import script from "./UpdateMailCharge.vue?vue&type=script&lang=js"
export * from "./UpdateMailCharge.vue?vue&type=script&lang=js"
import style0 from "./UpdateMailCharge.vue?vue&type=style&index=0&id=baf8e4d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf8e4d0",
  null
  
)

export default component.exports